import { ReactNode } from 'react';
import { Button, Form as FormB } from 'react-bootstrap';

interface FormProps {
  title?: string;
  subtitle?: string;
  size?: 'medium' | 'large' | 'full';
  noBtns?: boolean;
  submitText?: string;
  resetText?: string;
  btns?: ('submit' | 'reset')[];
  disableBtns?: boolean;
  extraBtns?: JSX.Element[];
  children?: ReactNode;
  onSubmit?: any;
  onClear?: any;
}

export default function CustomForm(props: FormProps) {
  return (
    <>
      <FormB>
        {props.children}
        {props.btns && (
          <div style={{ float: 'right', marginTop: '10pt', marginBottom: '20pt' }}>
            {props.btns.find((b) => b == 'reset') && (
              <Button variant="secondary" onClick={props.onClear}>
                Deshacer cambios
              </Button>
            )}{' '}
            {props.btns.find((b) => b == 'submit') && (
              <Button
                variant="success"
                onClick={props.onSubmit}
                style={{ marginLeft: '10pt' }}
                disabled={props.noBtns}>
                {props.submitText}
              </Button>
            )}
          </div>
        )}
      </FormB>
    </>
  );
}
